import { useCallback } from 'react';

import { hasNavigatorApi, hasWindow } from 'utils/browser.utils';

export const useClipboard = () => {
  const writeToClipboard = useCallback((data: string) => {
    if (!hasWindow()) return;
    if (hasNavigatorApi('clipboard')) {
      return navigator.clipboard.writeText(data);
    }
  }, []);

  return writeToClipboard;
};
